import styled from '@emotion/styled'
import { Grid } from '@mui/material'
import React from 'react'
import { SubHeading } from '../../../../../Components/SubHeading'
import { Text } from '../../../../../Components/Text'

const FeaturesImg = styled.img`
    width: auto;
    height: 70px;
    margin-bottom: 1.5rem;
`
const CardWrapper = styled.div`
    background-color: #101339;
    padding: 2.5rem 1.5rem;
    text-align: center;
    border: 5px;
    
    @media (max-width: 899px){
        max-width: 280px;
        margin: auto;
    }
`
const TextWrapper = styled.div`
    min-height: unset;
    @media (min-width: 600px){ min-height: 160px; }
    @media (min-width: 702px){ min-height: 138px; }
    @media (min-width: 900px){ min-height: 162px; }
    @media (min-width: 1029px){ min-height: 138px; }
    @media (min-width: 1124px){ min-height: 115px; }
    @media (min-width: 1220px){ min-height: 115px; }
    @media (min-width: 1455px){ min-height: 90px; }
`

export const FeaturesCard = (props) => {
  return (
    <Grid item xs={12} sm={6} md={4} className="p-2 p-sm-2 p-lg-4">
        <CardWrapper>
            <FeaturesImg src={props.cardIcon} />
            <SubHeading>{props.cardHeading}</SubHeading>
            <TextWrapper>
                <Text mb="0px">{props.discription}</Text>
            </TextWrapper>
        </CardWrapper>
    </Grid>
  )
}
